import {ContentSliderBarItem} from "@web-libs/ui/ui-components/slider/content-slider-bar-item";

export const ContentSliderBar = ({count, activeIndex, onClick} : {count: number, activeIndex: number, onClick: (index:number) => void}) => {
    return (
        <div style={{display:"flex", height:20, alignItems:"end"}}>
            {Array.from(Array(count).keys()).map((index) => {
                const _styles = {
                  ...(index == 0 ? {} : {marginLeft: 8})
                }
               return <ContentSliderBarItem style={_styles} key={index} active={index == activeIndex} onClick={() => onClick(index)}></ContentSliderBarItem>
            })}
        </div>
    )
}
